import { DemoMenuControllerApi } from '@/lib/api/generated/casedb';
import { catalogApiClient } from '@/features/catalog_case_review/shared/services/catalogApiClient';

export async function getDemoMenuConfiguration() {
  return (await (await catalogApiClient(DemoMenuControllerApi)).demoMenuConfiguration({ timeout: 10000 })).data;
}
